import { render, staticRenderFns } from "./ApiServiceError.vue?vue&type=template&id=b899e4b6&scoped=true&"
import script from "./ApiServiceError.ts?vue&type=script&lang=ts&"
export * from "./ApiServiceError.ts?vue&type=script&lang=ts&"
import style0 from "./ApiServiceError.scss?vue&type=style&index=0&id=b899e4b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b899e4b6",
  null
  
)

export default component.exports